var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work-flow"},[_c('img',{attrs:{"src":require('/src/assets/img/odc/general-agile.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }